import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import {
  convertToCurrencyFormat,
  stockUnitOfMeasureOptions,
  isReadOnlyUser,
} from "../../../shared/utility";
import SelectMenu from "../../controls/SelectMenu";
import OrderSubtable1 from "./subtables/OrderSubtable1";

export default function OrderProductsTable(props) {
  const {
    loading,
    values,
    onItemEditComplete,
    rowDetails,
    fetchRowDetails,
    loadingRows,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    selectedItems,
    setSelectedItems,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const allowExpansion = (rowData) => {
    return true;
  };

  const rowExpansionTemplate = (data) => {
    return (
      <OrderSubtable1
        data={data}
        loadingRows={loadingRows}
        rowDetails={rowDetails}
        fetchSubRowDetails={fetchSubRowDetails}
        subRowDetails={subRowDetails}
        subLoadingRows={subLoadingRows}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
    );
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const itemTypeDropdown = (options) => {
    return (
      <SelectMenu
        handleInputChange={(e) => {
          options.editorCallback(e.target.value.value);
        }}
        name="unit_type"
        options={stockUnitOfMeasureOptions}
        value={stockUnitOfMeasureOptions.find(
          (el) => el.value === options.rowData.unit_type,
        )}
        showLabel={false}
        menuPortalTarget={document.body}
      />
    );
  };

  const onRowEditComplete = (e) => {
    let { newData, index } = e;

    var newTotalCost = 0;
    if (newData.unit_type === 2) {
      newTotalCost = newData.unit_cost * newData.total_in_lbs;
    } else if (newData.unit_type === 3) {
      newTotalCost = newData.unit_cost * newData.total_in_pieces;
    } else {
      newTotalCost = newData.unit_cost * newData.total_in_kg;
    }

    newData["total_cost"] = newTotalCost;

    onItemEditComplete(newData, index);
  };

  const productDetailsBody = (rowData) => {
    return (
      <p>
        <span className="text-gray-900 font-semibold">
          {rowData.product_name}
        </span>
        <br />
        <span className="text-gray-700">PLU:{rowData.plu}</span>
      </p>
    );
  };

  const unitCostBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.unit_cost)}</p>;
  };

  const totalCostBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.total_cost)}</p>;
  };

  const totalCartonsParent = (rowData) => {
    return (
      <div>
        <p>{rowData.total_cartons} cartons</p>
      </div>
    );
  };

  const totalShippedWeightParent = (rowData) => {
    return (
      <div>
        <p>{rowData.total_in_kg}kg</p>
        <p>{rowData.total_in_lbs}lbs</p>
        <p>{rowData.total_in_pieces} pieces</p>
      </div>
    );
  };

  const unitTypeBody = (value) => {
    switch (value.unit_type) {
      case 1:
        return "kg";

      case 2:
        return "lbs";

      case 3:
        return "pieces";

      default:
        return "N/A";
    }
  };

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!rowDetails[rowData.unique_id]) {
      fetchRowDetails(rowData);
    }
  };
  const isReadOnly = isReadOnlyUser();

  return (
    <div className="w-full overflow-x-auto">
      <div className="min-w-[900px] py-2">
          {loading ? (
            <div>
              <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading</div>
              </div>
            </div>
          ) : (
            <div className="overflow-hidden">
              <DataTable
                value={values.items}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                  setExpandedRows(e.data);
                }}
                onRowExpand={onRowExpand}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="id"
                tableClassName="min-w-full bg-white divide-y divide-gray-300 create-order-inventory-table-parent"
                cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
                editMode="row"
                onRowEditComplete={onRowEditComplete}
              >
                <Column header="Product" body={productDetailsBody} />
                <Column header="Lot Number" field="lot_number" />

                <Column
                  header="Shipped Cartons"
                  body={totalCartonsParent}
                  style={{ textAlign: "right" }}
                />

                <Column
                  header="Shipped amount"
                  body={totalShippedWeightParent}
                  style={{ textAlign: "right" }}
                />

                <Column
                  header="Unit Cost"
                  field="unit_cost"
                  style={{ textAlign: "right" }}
                  body={unitCostBody}
                  editor={(options) => textEditor(options)}
                />

                <Column
                  header="Total Cost"
                  field="total_cost"
                  style={{ textAlign: "right" }}
                  body={totalCostBody}
                />

                <Column
                  header="Unit Type"
                  field="unit_type"
                  headerStyle={{ minWidth: "8rem" }}
                  body={unitTypeBody}
                  editor={(options) => itemTypeDropdown(options)}
                />
                {!isReadOnly && (
                  <Column
                    rowEditor={true}
                    headerStyle={{ minWidth: "6rem" }}
                    bodyStyle={{ textAlign: "center" }}
                  />
                )}
                <Column expander={allowExpansion} style={{ width: "6%" }} />
              </DataTable>
            </div>
          )}
          <div className="w-full text-right mt-4">
            <p className="font-bold">
              Subtotal: {convertToCurrencyFormat(values.subtotal_dollar_amount)}
            </p>
            <p className="font-bold">
              Taxes: {convertToCurrencyFormat(values.tax_amount)}
            </p>
            <p className="font-bold">
              Total: {values.currency?.label || ""}{" "}
              {convertToCurrencyFormat(values.total_dollar_amount)}
            </p>
          </div>
      </div>
    </div>
  );
}
